import { useState, useEffect } from "react";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export const useWindowDimensions = () => {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
};

export const numericInput = (stringNumber) => {
  if (!stringNumber) {
    return "";
  }
  return stringNumber.trim().replace(/[^0-9.-]/g, "");
};

export const getAreaList = (projectId) => {
  try {
    let listData = JSON.parse(localStorage.getItem("data_list"));
    const listFilter = listData.filter((e) =>
      projectId === "" ? e : Number(e.project_id === Number(projectId))
    );

    if (listFilter.length > 0) {
      listData = listFilter;
    }
    const listDataReduce = listData
      .reduce(
        (total, item) =>
          total + `${item.work_center_list?.replace(/;/g, ",")},`,
        ""
      )
      .split(",")
      .filter((e) => e !== "");
    console.log("getAreaList > ", projectId, listDataReduce);
    const distinctArray = [...new Set(listDataReduce)];
    return distinctArray.sort();
  } catch (error) {
    return [];
  }
};
